// Help — TradeFlow design (light, mobile-first, Apple fintech)
// Simple help FAQ page using TfCard primitives

import { TfCard } from '../../components/TfPrimitives';

const FAQ = [
  { q: 'How do I start a new challenge?', a: 'Go to Platforms, pick the size you want, and complete checkout. You\'ll get instant access to your funded account dashboard.' },
  { q: 'What is the minimum deposit?', a: 'The minimum is the cost of the challenge tier you select. The Starter challenge is the lowest entry point.' },
  { q: 'When can I request a payout?', a: 'Daily payouts unlock after you\'ve claimed 3 payouts in total from your funded account.' },
  { q: 'How do I reset my password?', a: 'Go to /forgot-password and enter the email you registered with. We\'ll send a reset link.' },
  { q: 'Can I use my own trading platform?', a: 'Yes. Once you have a Challenge or Market Data subscription, you can connect any supported platform via the Platforms page.' },
  { q: 'What\'s the difference between a Challenge and a funded account?', a: 'A Challenge is the evaluation phase — pass it to unlock a funded account where you trade the firm\'s capital and keep up to 90% of profits.' },
];

export function HelpPage() {
  return (
    <div className="space-y-4 p-4">
      <h1 className="px-1 text-[34px] font-bold leading-[1.1] tracking-tight text-tf-text-1">Help & FAQ</h1>
      <p className="px-1 text-[15px] text-tf-text-3">Find answers to common questions about your Funder Pro account.</p>
      <div className="space-y-2">
        {FAQ.map((f, i) => (
          <TfCard key={i} className="p-0" testId={`faq-${i}`}>
            <details className="group">
              <summary className="flex cursor-pointer list-none items-center justify-between px-4 py-3 text-[15px] font-semibold text-tf-text-1 active:bg-tf-surface-1">
                {f.q}
                <svg viewBox="0 0 24 24" className="h-5 w-5 text-tf-text-3 transition-transform group-open:rotate-180" fill="none" stroke="currentColor" strokeWidth="2"><path d="M6 9l6 6 6-6" strokeLinecap="round"/></svg>
              </summary>
              <p className="border-t border-tf-border px-4 py-3 text-[14px] leading-relaxed text-tf-text-2">{f.a}</p>
            </details>
          </TfCard>
        ))}
      </div>
      <TfCard className="p-5 text-center">
        <div className="text-[24px]">💬</div>
        <h2 className="mt-2 text-[17px] font-bold text-tf-text-1">Still need help?</h2>
        <p className="mt-1 text-[13px] text-tf-text-3">Reach out to support@funderprofutures.com or tap the chat widget at the bottom right.</p>
      </TfCard>
    </div>
  );
}
